import PropTypes from "prop-types";
import useSettings from "@/hooks/useSettings";

const Template4 = ({ template, previewData }) => {
  const {
    settings: { restaurant = {} },
  } = useSettings();
  const isStrictPreview = Boolean(previewData?.strictTablePreview);
  const backgroundImage = template?.image_url || null;
  const restaurantName =
    restaurant?.outlet_name ||
    restaurant?.legal_name ||
    previewData?.restaurantName ||
    previewData?.businessName ||
    previewData?.restaurant_name ||
    (isStrictPreview ? "No provide" : "NAGA INDIAN");
  const address =
    restaurant?.address ||
    previewData?.address ||
    previewData?.restaurant_address ||
    (isStrictPreview
      ? "No provide"
      : "68 Brick Ln, London E1 6RL, United Kingdom");
  const phone =
    restaurant?.phone ||
    previewData?.phone ||
    previewData?.restaurant_phone ||
    (isStrictPreview ? "No provide" : "011-23236767");
  const tin =
    restaurant?.vat_id ||
    previewData?.tin ||
    previewData?.restaurant_tin 
  const website =
    restaurant?.website ||
    previewData?.website ||
    previewData?.restaurant_website ||
    (isStrictPreview ? "No provide" : "www.demo.com");
  const moto = restaurant?.moto || previewData?.restaurant_moto || null;
  const bid = restaurant?.bid || previewData?.restaurant_bid || null;
  const title =
    previewData?.title || previewData?.note || (isStrictPreview ? "No provide" : "Gift Voucher");
  const customerName =
    previewData?.customerName ||
    previewData?.customer_name ||
    previewData?.receiver_full_name ||
    previewData?.receiver?.full_name ||
    (isStrictPreview ? "No provide" : "Md Rasel Mahmud");
  const payerName =
    previewData?.payer_full_name ||
    previewData?.payer?.full_name ||
    previewData?.fromName ||
    previewData?.previewMessage ||
    null;
  const code = previewData?.code || (isStrictPreview ? "No provide" : "326562356");
  const reward = previewData?.reward ?? previewData?.reward_amount ?? null;
  const message = previewData?.template_note 
    // (isStrictPreview ? "No provide" : "Happy Birthday Massage");

  return (
    <div className="flex items-center justify-center bg-white p-4">
      <div
        data-export-capture="c2c-template"
        className="w-full max-w-[420px]  bg-white p-4 font-mono text-black bg-cover bg-center"
        style={
          backgroundImage
            ? { backgroundImage: `url(${backgroundImage})` }
            : undefined
        }
      >
        <div className="space-y-3 bg-white">
          <div className="space-y-1 text-center leading-tight">
            <h1 className="text-[24px] font-extrabold uppercase tracking-tight">
              {restaurantName}
            </h1>
            {moto ? <p className="text-[14px] font-bold">{moto}</p> : null}
            {bid ? <p className="text-[14px] font-bold">BID : {bid}</p> : null}
            <p className="text-[16px] font-bold">{address}</p>
            <p className="text-[16px] font-bold">Phone : {phone}</p>
            {
              tin ? <p className="text-[16px] font-bold">TIN No : {tin}</p> : null
            }
            <p className="text-[16px] font-bold">website: {website}</p>
          </div>

          <div className="border-t border-dashed border-black" />

          <div className="space-y-3 pt-1 text-[18px] font-bold leading-tight">
            <p className="text-[20px]">{title}</p>
            <p>{customerName}</p>
            {payerName ? <p>From: {payerName}</p> : null}
            {reward !== null && reward !== undefined && reward !== "" ? (
              <p>Reward: £{reward}</p>
            ) : null}
            <p>Code: {code}</p>

            {previewData?.items && previewData.items.length > 0 ? (
              <div className="mt-2 space-y-1">
                <p className="text-[16px] underline">Included Items:</p>
                {previewData.items.map((item, index) => (
                  <p key={index} className="text-[16px] pl-2 font-mono">
                    - {item?.menu_item?.name || item?.name || ""}
                    {item?.variant?.name ? ` (${item.variant.name})` : item?.variant_name ? ` (${item.variant_name})` : ""}
                  </p>
                ))}
              </div>
            ) : null}

            <p>“{message ?? "Message"}”</p>
          </div>
        </div>
      </div>
    </div>
  );
};

Template4.propTypes = {
  template: PropTypes.shape({
    image_url: PropTypes.string,
  }),
  previewData: PropTypes.shape({
    strictTablePreview: PropTypes.bool,
    restaurantName: PropTypes.string,
    businessName: PropTypes.string,
    restaurant_name: PropTypes.string,
    address: PropTypes.string,
    restaurant_address: PropTypes.string,
    phone: PropTypes.string,
    restaurant_phone: PropTypes.string,
    tin: PropTypes.string,
    restaurant_tin: PropTypes.string,
    website: PropTypes.string,
    restaurant_website: PropTypes.string,
    restaurant_moto: PropTypes.string,
    restaurant_bid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    note: PropTypes.string,
    customerName: PropTypes.string,
    customer_name: PropTypes.string,
    receiver_full_name: PropTypes.string,
    receiver: PropTypes.shape({
      full_name: PropTypes.string,
    }),
    payer_full_name: PropTypes.string,
    payer: PropTypes.shape({
      full_name: PropTypes.string,
    }),
    fromName: PropTypes.string,
    previewMessage: PropTypes.string,
    code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    reward: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    reward_amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    message: PropTypes.string,
    template_note: PropTypes.string,
  }),
};

export default Template4;
